import { render, staticRenderFns } from "./cadgrupossaidaspdv.vue?vue&type=template&id=7bcf8188&"
import script from "./cadgrupossaidaspdv.vue?vue&type=script&lang=js&"
export * from "./cadgrupossaidaspdv.vue?vue&type=script&lang=js&"
import style0 from "./cadgrupossaidaspdv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports